import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mantine/core'
import config from '@/core/config'

interface AdsenseProps {
  slot: string
  width?: number | string
  height?: number | string
  style?: React.CSSProperties
  isTest?: boolean
  className?: string
  isResponsive?: boolean
}

const Adsense: React.FC<AdsenseProps> = ({
  slot,
  width = '100%',
  height = 'auto',
  style,
  isTest = process.env.NODE_ENV === 'development',
  className,
  isResponsive = true
}) => {
  const adRef = useRef<HTMLDivElement>(null)
  const [ready, setReady] = useState(false)
  const isProd = config.app.isProd

  useEffect(() => {
    if (!isProd) return
    console.log('[Adsense] Component mounted', { slot, isTest, width, height })
    if (!adRef.current) return

    const checkSize = () => {
      if (adRef.current) {
        const rect = adRef.current.getBoundingClientRect()
        console.log('[Adsense] Checking container size', { width: rect.width, height: rect.height, slot })
        if (rect.width > 0 && rect.height > 0) {
          setReady(true)
        }
      }
    }

    checkSize()
    window.addEventListener('resize', checkSize)
    return () => window.removeEventListener('resize', checkSize)
  }, [isProd])

  useEffect(() => {
    if (!isProd || !ready) return
    console.log('[Adsense] Container ready, initializing ad', { slot })
    try {
      // @ts-ignore
      ;(window.adsbygoogle = window.adsbygoogle || []).push({})
      console.log('[Adsense] adsbygoogle.push() called', { slot })
    } catch (e) {
      console.error('[Adsense] Error pushing adsbygoogle', e, { slot })
    }
  }, [isProd, ready])

  // Don't show ads on non-prod environments
  if (!isProd) {
    return null
  }

  console.log('[Adsense] Render', { slot, width, height })

  return (
    <Box ref={adRef} mah={height} h={height} w={width} maw={width} style={{ overflow: 'hidden' }}>
      <ins
        className={`adsbygoogle ${className || ''}`}
        data-ad-client="ca-pub-1628939849575997"
        data-ad-slot={slot}
        data-ad-format={isResponsive ? 'auto' : 'fixed'}
        data-full-width-responsive={isResponsive ? 'true' : 'false'}
        style={{
          display: 'block',
          width: typeof width === 'number' ? `${width}px` : width,
          height: typeof height === 'number' ? `${height}px` : height,
          ...style
        }}
      />
    </Box>
  )
}

export default Adsense
